// Configuración de Firebase para el Admin Dashboard
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getFunctions } from "firebase/functions";

// Reemplazar con los valores reales desde la Consola de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyA3mKwVAlXF4qQO5tDUFacDZpOL2Ql_B54",
  authDomain: "mototaxi-vzla-app.firebaseapp.com",
  databaseURL: "https://mototaxi-vzla-app-default-rtdb.firebaseio.com",
  projectId: "mototaxi-vzla-app",
  storageBucket: "mototaxi-vzla-app.firebasestorage.app",
  messagingSenderId: "553623965954",
  appId: "1:553623965954:web:4822eac81c689ab6d1321b"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export const functions = getFunctions(app);
